module.exports = __webpack_public_path__ + "img/drawer_bottom_bg.afc5177b.png";